import LiveRampDefaultImg from '@/assets/destinations/LiveRamp-Default.png'
import LiveRampSelectedImg from '@/assets/destinations/LiveRamp-Selected.png'
import SymphonyDefaultImg from '@/assets/destinations/Symphony-Default.png'
import SymphonySelectedImg from '@/assets/destinations/Symphony-Selected.png'
import KruxDefaultImg from '@/assets/destinations/Krux-Default.png'
import KruxSelectedImg from '@/assets/destinations/Krux-Selected.png'
import DirecTVDefaultImg from '@/assets/destinations/DirecTV-Default.png'
import DirecTVSelectedImg from '@/assets/destinations/DirecTV-Selected.png'
import VizioDefaultImg from '@/assets/destinations/Vizio-Default.png'
import VizioSelectedImg from '@/assets/destinations/Vizio-Selected.png'
import CanoeDefaultImg from '@/assets/destinations/Canoe-Default.png'
import CanoeSelectedImg from '@/assets/destinations/Canoe-Selected.png'
import CanoeVODDefault from '@/assets/destinations/Canoe_VOD-Default.png'
import CanoeVODSelected from '@/assets/destinations/Canoe_VOD-Selected.png'
import ForesiteDefaultImg from '@/assets/destinations/Foresite-Default.png'
import ForesiteSelectedImg from '@/assets/destinations/Foresite-Selected.png'
import Lake5DefaultImg from '@/assets/destinations/Lake5-Default.png'
import Lake5SelectedImg from '@/assets/destinations/Lake5-Selected.png'
import FreewheelDefaultImg from '@/assets/destinations/Freewheel-Default.png'
import FreewheelSelectedImg from '@/assets/destinations/Freewheel-Selected.png'
import GamDefaultImg from '@/assets/destinations/GAM-Default.png'
import GamSelectedImg from '@/assets/destinations/GAM-Selected.png'
import VideoampDefaultImg from '@/assets/destinations/Videoamp-Default.png'
import VideoampSelectedImg from '@/assets/destinations/Videoamp-Selected.png'

const ACTIVATION_STATUS = {
  DRAFT: 'DRAFT',
  NEW: 'NEW',
  WORKING: 'WORKING',
  ASSIGNED: 'ASSIGNED',
  ACTIVATED: 'ACTIVATED',
  POSTED: 'FORECASTED',
  SUBMITTED: 'SUBMITTED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  LIVE: 'LIVE',
  MODELING: 'MODELING',
  MODELED: 'MODELED',
  MODEL_FAILED: 'MODEL FAILED',
}

const ATT_STATUS = {
  PLANNING: 'Planning',
  ORDERED: 'Ordered',
  CANCELLED: 'Cancelled',
  // POSTED: 'FORECASTED'
}

const TARGET_TYPE = {
  LAS: 'linear_ad_sales',
  SD: 'social_digital',
  AD: 'audience_discovery',
  COMSCORE_TV: 'comscore_tv',
  NPOWER: 'npower',
  PID: 'pid',
  ATT: 'att-dtv',
  XANDR_SEGMENT: 'xandr_segment',
  COMSCORE: 'comscore',
  ADSTRA: 'adstra',
  PRISM: 'prism',
  DNB: 'dnb',
  MAX: 'max',
  BYOD: 'byod',
  VIDEOAMP: 'videoamp',
  TVE: 'tve',
  EPSILON: 'epsilon',
  DISCOVERY_PLUS: 'd+',
  DCR: 'dcr',
  DC_COMICS: 'dc_comics',
  LIVERAMP: 'liveramp',
  WBGAMES: 'wbgames',
  RETARGETING: 'retargeting',
  FREEWHEEL: 'FreeWheel',
  GOOGLE_AD_MANAGER: 'GoogleAdManager',
  LAL: 'LAL',
}

const TARGET_TYPE_FILTER = {
  LAS: {
    name: 'Linear Ad Sales',
    value: 'linear_ad_sales',
    checked: true,
    visible: true,
  },
  SD: {
    name: 'Social Digital',
    value: 'social_digital',
    checked: true,
    visible: true,
  },
  AD: {
    name: 'Audience Discovery',
    value: 'audience_discovery',
    checked: true,
    visible: true,
  },
  NPOWER: {
    name: 'Npower',
    value: 'npower',
    checked: true,
    visible: true,
  },
  PID: {
    name: 'PID',
    value: 'pid',
    checked: true,
    visible: true,
  },
  ATT: {
    name: 'Xandr File',
    value: 'att-dtv',
    checked: true,
    visible: true,
  },
  XANDR_SEGMENT: {
    name: 'Xandr Linear',
    value: 'xandr_segment',
    checked: true,
    visible: true,
  },
  ADSTRA: {
    name: 'Adstra',
    value: 'adstra',
    checked: true,
    visible: true,
  },
  COMSCORE: {
    name: 'Custom',
    value: 'comscore',
    checked: true,
    visible: true,
  },
  OPENAP: {
    name: 'OpenAP',
    value: 'openap',
    checked: true,
    visible: true,
  },
}

const SOURCES_FILTER = {
  AMRLD: {
    name: 'AMRLD',
    value: 'amrld',
    checked: true,
    visible: true,
  },
  MRI: {
    name: 'MRI',
    value: 'mri',
    checked: true,
    visible: true,
  },
  NIELSEN: {
    name: 'NPOWER',
    value: 'npower',
    checked: true,
    visible: true,
  },
  OPENAP: {
    name: 'OPENAP',
    value: 'openap',
    checked: true,
    visible: true,
  },
  EPSILON: {
    name: 'EPSILON',
    value: 'epsilon',
    checked: true,
    visible: true,
  },
  NCS: {
    name: 'NCS',
    value: 'ncs',
    checked: true,
    visible: true,
  },
  PID: {
    name: 'PID',
    value: 'pid',
    checked: true,
    visible: true,
  },
  ADSTRA: {
    name: 'ADSTRA',
    value: 'adstra',
    checked: true,
    visible: true,
  },
  COMSCORE: {
    name: 'COMSCORE',
    value: 'comscore',
    checked: true,
    visible: true,
  },
  COMSCORE_TV: {
    name: 'COMSCORE_TV',
    value: 'comscore_tv',
    checked: true,
    visible: true,
  },
  PRISM: {
    name: 'PRISM',
    value: 'prism',
    checked: true,
    visible: true,
  },
  DNB: {
    name: 'DNB',
    value: 'dnb',
    checked: true,
    visible: true,
  },
  MAX: {
    name: 'MAX',
    value: 'max',
    checked: true,
    visible: true,
  },
  TVE: {
    name: 'TVE',
    value: 'tve',
    checked: true,
    visible: true,
  },
  DCR: {
    name: 'DCR',
    value: 'dcr',
    checked: true,
    visible: true,
  },
  DC_COMICS: {
    name: 'DC_COMICS',
    value: 'dc_comics',
    checked: true,
    visible: true,
  },
  BYOD: {
    name: 'BYOD',
    value: 'byod',
    checked: true,
    visible: true,
  },
  VIDEOAMP: {
    name: 'VIDEOAMP',
    value: 'videoamp',
    checked: true,
    visible: true,
  },
  DISCOVERY_PLUS: {
    name: 'D+',
    value: 'd+',
    checked: true,
    visible: true,
  },
  LIVERAMP: {
    name: 'LIVERAMP',
    value: 'liveramp',
    checked: true,
    visible: true,
  },
  WBGAMES: {
    name: 'WBGAMES',
    value: 'wbgames',
    checked: true,
    visible: true,
  },
  RETARGETING: {
    name: 'RETARGETING',
    value: 'retargeting',
    checked: true,
    visible: true,
  },
  FREEWHEEL: {
    name: 'FreeWheel',
    value: 'FreeWheel',
    checked: true,
    visible: true,
  },
  GOOGLE_AD_MANAGER: {
    name: 'Google Ad Manager',
    value: 'GoogleAdManager',
    checked: true,
    visible: true,
  },
  LAL: {
    name: 'LAL',
    value: 'LAL',
    checked: true,
    visible: true,
  },
}

const TARGET_TYPES_INTEGERS = {
  LAS: 1,
  AD: 2,
  SD: 3,
  NPOWER: 4,
  PID: 5,
  ATT: 6,
  COMSCORE_TV: 7,
  XANDR_SEGMENT_ADVERTISING: 8,
  XANDR_SEGMENT_RESEARCH: 9,
  XANDR_SEGMENT_MARKETING: 10,
  COMSCORE: 11,
  ADSTRA: 12,
  PRISM: 13,
  BYOD: 14,
  DNB: 15,
  MAX: 16,
  TVE: 17,
  VIDEOAMP: 19,
  DISCOVERY_PLUS: 18,
  DCR: 21,
  DC_COMICS: 28,
  LIVERAMP: 22,
  WBGAMES: 23,
  RETARGETING: 24,
  FREEWHEEL: 25,
  GOOGLE_AD_MANAGER: 26,
  LAL: 27,
}

const actions = {
  ALL_TARGETS: 'ALL_TARGETS',
  MY_OPEN_AP: 'MY_OPEN_AP',
  OPEN_AP: 'ALL_OPEN_AP',
  MY_TARGETS: 'MY_TARGETS',
  ARCHIVED_TARGETS: 'ARCHIVED_TARGETS',
  MY_ARCHIVED_TARGETS: 'MY_ARCHIVED_TARGETS',
}

const DESTINATIONS = {
  SYMPHONY: 'Symphony',
  KRUX: 'Krux',
  LIVERAMP: 'LiveRamp',
  DIRECTV: 'DirecTV',
  ATT_TV: 'AT&T-TV',
  VIZIO: 'Vizio',
  CANOE_LINEAR: 'CanoeLinear',
  CANOE_VOD: 'CanoeVOD',
  FORESITE: 'Foresite',
  FREEWHEEL: 'FreeWheel',
  GOOGLE_AD_MANAGER: 'GoogleAdManager',
  BLANK: 'Blank',
  LAKE5: 'Lake5',
  VIDEOAMP: 'VideoAmp',
}

const DESTINATIONS_ID = {
  DIRECTV_49: '49',
  DIRECTV_350: '350',
  VIZIO: '103',
}

// NOTE: for some reason when a filter option's name is the same as the value, the filter state exhibits weird behavior with group filter options (see AM-3530)
const DESTINATIONS_FILTER = {
  SYMPHONY: {
    name: 'Symphony',
    value: 'Symphony',
    checked: true,
    visible: true,
  },
  KRUX: {
    name: 'Krux',
    value: 'Krux',
    checked: true,
    visible: true,
  },
  LIVERAMP: {
    name: 'LiveRamp',
    value: 'LiveRamp',
    checked: true,
    visible: true,
  },
  FREEWHEEL: {
    name: 'FreeWheel',
    value: 'FreeWheel',
    checked: true,
    visible: true,
  },
  GOOGLE_AD_MANAGER: {
    name: 'Google Ad Manager',
    value: 'GoogleAdManager',
    checked: true,
    visible: true,
  },
  DIGITAL: {
    name: 'Digital',
    value: ['FreeWheel', 'GoogleAdManager'],
    checked: true,
    visible: true,
  },
  SOCIAL_DIGITAL: {
    name: 'Social Digital',
    value: ['Krux', 'LiveRamp'],
    checked: true,
    visible: true,
  },
  DIRECTV: {
    name: 'DirecTV',
    value: 'DirecTV',
    checked: true,
    visible: true,
  },
  VIZIO: {
    name: 'Vizio',
    value: 'Vizio',
    checked: true,
    visible: true,
  },
  CANOE_LINEAR: {
    name: 'Canoe Linear',
    value: 'CanoeLinear',
    checked: true,
    visible: true,
  },
  CANOE_VOD: {
    name: 'Canoe VOD',
    value: 'CanoeVOD',
    checked: true,
    visible: true,
  },
  ADDRESSABLE: {
    name: 'Addressable',
    value: ['DirecTV', 'Vizio', 'CanoeLinear', 'CanoeVOD'],
    checked: true,
    visible: true,
  },
  FORESITE: {
    name: 'Foresite',
    value: 'Foresite',
    checked: true,
    visible: true,
  },
  BLANK: {
    name: '(Blanks)',
    value: 'Blank',
    checked: true,
    visible: true,
  },
  LAKE5: {
    name: 'Lake5',
    value: 'Lake5',
    checked: true,
    visible: true,
  },
  VIDEOAMP: {
    name: 'VideoAmp',
    value: 'VideoAmp',
    checked: true,
    visible: true,
  },
}

const DESTINATION_OBJECTS = [
  {
    id: DESTINATIONS.SYMPHONY,
    img: {
      default: SymphonyDefaultImg,
      selected: SymphonySelectedImg,
    },
    isDisabled: false,
  },
  {
    id: DESTINATIONS.KRUX,
    img: {
      default: KruxDefaultImg,
      selected: KruxSelectedImg,
    },
    isDisabled: false,
  },
  {
    id: DESTINATIONS.LIVERAMP,
    img: {
      default: LiveRampDefaultImg,
      selected: LiveRampSelectedImg,
    },
    isDisabled: false,
  },
  {
    id: DESTINATIONS.VIZIO,
    label: DESTINATIONS.VIZIO + ' (OAR)',
    img: {
      default: VizioDefaultImg,
      selected: VizioSelectedImg,
    },
    isDisabled: false,
    isHidden: !process.env.ENABLE_ADDRESSABLE,
  },
  {
    id: DESTINATIONS.DIRECTV,
    img: {
      default: DirecTVDefaultImg,
      selected: DirecTVSelectedImg,
    },
    isDisabled: false,
    isHidden: !process.env.ENABLE_ADDRESSABLE,
  },
  {
    id: DESTINATIONS.CANOE_LINEAR,
    label: 'Canoe Linear',
    img: {
      default: CanoeDefaultImg,
      selected: CanoeSelectedImg,
    },
    isDisabled: false,
    isHidden: !process.env.ENABLE_ADDRESSABLE,
  },
  {
    id: DESTINATIONS.CANOE_VOD,
    label: 'Canoe VOD',
    img: {
      default: CanoeVODDefault,
      selected: CanoeVODSelected,
    },
    isDisabled: false,
    isHidden: !process.env.ENABLE_ADDRESSABLE,
  },
  {
    id: DESTINATIONS.FORESITE,
    label: 'Foresite',
    img: {
      default: ForesiteDefaultImg,
      selected: ForesiteSelectedImg,
    },
    isDisabled: false,
  },
  {
    id: DESTINATIONS.FREEWHEEL,
    img: {
      default: FreewheelDefaultImg,
      selected: FreewheelSelectedImg,
    },
    isDisabled: false,
  },
  {
    id: DESTINATIONS.GOOGLE_AD_MANAGER,
    img: {
      default: GamDefaultImg,
      selected: GamSelectedImg,
    },
    isDisabled: false,
  },
  {
    id: DESTINATIONS.LAKE5,
    label: 'Lake5',
    img: {
      default: Lake5DefaultImg,
      selected: Lake5SelectedImg,
    },
    isDisabled: false,
  },
  {
    id: DESTINATIONS.VIDEOAMP,
    label: 'VideoAmp',
    img: {
      default: VideoampDefaultImg,
      selected: VideoampSelectedImg,
    },
    isDisabled: false,
  },
]

const VIEWING_STREAMS = {
  LIVE: 'live',
  LSD: 'lsd',
  C3: 'c3',
  C7: 'c7',
  LIVE3: 'l3',
}

const LAS_TYPES = {
  ATT: 'AT&T',
  AM: 'Audience Matters',
  NPOWER: 'NPOWER',
  COMSCORE: 'COMSCORE',
  PID: 'PID',
  XANDR: 'Xandr',
}

const LAS_OPTIONS = [
  { Name: 'Xandr Upload', value: LAS_TYPES.XANDR },
  { Name: 'Audience Matters', value: LAS_TYPES.AM },
  { Name: 'NPower Upload', value: LAS_TYPES.NPOWER },
  { Name: 'PID Upload', value: LAS_TYPES.PID },
  { Name: 'Xandr', value: LAS_TYPES.XANDR },
]

const STREAMING_OPTIONS = [
  { Name: 'Live', value: VIEWING_STREAMS.LIVE },
  { Name: 'Live Same Day', value: VIEWING_STREAMS.LSD },
  { Name: 'C7', value: VIEWING_STREAMS.C7 },
  { Name: 'C3', value: VIEWING_STREAMS.C3 },
]

const FREQUENCIES = {
  ONE_TIME: 'ONE TIME',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
}

const EXPORT_DAY_OF_WEEK = [
  { Name: 'Sunday', value: 0 },
  { Name: 'Thursday', value: 4 },
  { Name: 'Friday', value: 5 },
  { Name: 'Saturday', value: 6 },
]

const FIELDS = {
  targetType: 'target',
  lastUpdated: 'last_update',
  activationStatus: 'activation_status',
  datasources: 'target_datasource',
  viewingStream: 'viewing_stream',
  destinations: 'destinations',
}

const ATT_SELECT_TYPE_OPTIONS = {
  DAILY: 1,
  AD_HOC: 2,
  AUDIENCE_BUILDER: 3,
}

const TARGET_ACTIONS = {
  DUPLICATE: 'Duplicate',
  UPDATE: 'Update',
  UPDATE_CAMPAIGN: 'Update Campaign',
  NEW: 'New',
  SEGMENT_INFO: 'Segment Info',
  ACTIVATE: 'Activate',
}
// intent object in a format expected from Data City
const INTENTS = {
  Marketing: {
    Name: 'Marketing',
    IntentId: 1,
    IsActive: true,
  },
  Sales: {
    Name: 'Sales',
    IntentId: 2,
    IsActive: true,
  },
  Research: {
    Name: 'Research',
    IntentId: 3,
    IsActive: true,
  },
}

const FREQUENCY_OPTION_SET = {
  LINEAR: 1,
  XANDR_SOCIAL_DIGITAL: 3,
  DIRECTV: 4,
  VIZIO: 5,
  CANOE_LINEAR: 6,
  CANOE_VOD: 7,
  ADSTRA: 8,
  DIGITAL: 9,
  VIDEOAMP: 10,
}

const MARKETPLACE_ENDPOINTS = {
  DIRECTV: 'DirecTV',
  VIZIO: 'OAR',
  CANOE_LINEAR: 'Canoe Linear',
  CANOE_VOD: 'Canoe VOD',
}

const EXTERNAL_ENDPOINTS = {
  DIRECTV: '3',
  VIZIO: '6',
  CANOE_LINEAR: '8',
  CANOE_VOD: '9',
}

const LAS_DESTINATIONS = [DESTINATIONS.FORESITE]

const ADDRESSABLE_DESTINATIONS = [
  DESTINATIONS.DIRECTV,
  DESTINATIONS.VIZIO,
  ...(process.env.ENABLE_CANOE_LINEAR ? [DESTINATIONS.CANOE_LINEAR] : []),
  ...(process.env.ENABLE_CANOE_VOD ? [DESTINATIONS.CANOE_VOD] : []),
]

const DIGITAL_DESTINATIONS = [DESTINATIONS.FREEWHEEL, DESTINATIONS.GOOGLE_AD_MANAGER]

const DDL_DESTINATIONS = [DESTINATIONS.VIDEOAMP]

export {
  actions,
  ACTIVATION_STATUS,
  TARGET_TYPE,
  TARGET_TYPE_FILTER,
  DESTINATIONS,
  DESTINATIONS_ID,
  DESTINATIONS_FILTER,
  DESTINATION_OBJECTS,
  SOURCES_FILTER,
  VIEWING_STREAMS,
  STREAMING_OPTIONS,
  FIELDS,
  TARGET_TYPES_INTEGERS,
  LAS_TYPES,
  LAS_OPTIONS,
  ATT_STATUS,
  ATT_SELECT_TYPE_OPTIONS,
  FREQUENCIES,
  EXPORT_DAY_OF_WEEK,
  TARGET_ACTIONS,
  INTENTS,
  FREQUENCY_OPTION_SET,
  MARKETPLACE_ENDPOINTS,
  EXTERNAL_ENDPOINTS,
  LAS_DESTINATIONS,
  ADDRESSABLE_DESTINATIONS,
  DIGITAL_DESTINATIONS,
  DDL_DESTINATIONS,
}



// WEBPACK FOOTER //
// ./src/app/appLogic/targets/Constants.js